module.exports = __webpack_public_path__ + "media/site_templates/www.gascooktopinstallation.com.au/images/our_services_1-48462d24d38a24731921e25a9ff1cda7.jpg";